/**
 * Roda antes do React: ajusta manifest, ícones e theme-color para a marca do
 * hostname. Falha em silêncio — a página precisa abrir mesmo sem API.
 */
import { urlDoBranding } from '@eva/domain';
import { marcaDetectada as deteccao } from './marca-detectada';
import { aplicarMarcaNaAba } from './app/marcaNaAba';

const apiUrl = import.meta.env.VITE_API_URL || '';

// O manifest da marca. No domínio personalizado (A050) também — antes só o
// subdomínio trocava, e o Android instalava a marca de domínio próprio com o
// manifest da Eva. (O Safari lê o manifest só ao montar a página; para ele,
// quem resolve é a API, pelo host, no `/api/manifest` puro do index.html.)
const manifest = document.getElementById('app-manifest') as HTMLLinkElement | null;
if (manifest && deteccao.kind === 'slug') manifest.href = `${apiUrl}/api/manifest?prc=${encodeURIComponent(deteccao.identifier)}`;
if (manifest && deteccao.kind === 'host') manifest.href = `${apiUrl}/api/manifest?host=${encodeURIComponent(deteccao.identifier)}`;

const endpoint = `${apiUrl}${urlDoBranding(deteccao.identifier, deteccao.kind)}`;

fetch(endpoint)
  .then((r) => (r.ok ? r.json() : null))
  .then((data) => {
    if (!data) return;
    // Ícone da aba, ícone do iPhone e título (A079).
    aplicarMarcaNaAba(data);
    const primary = data?.branding?.colors?.primary;
    if (primary) document.getElementById('theme-color')?.setAttribute('content', primary);
  })
  .catch(() => undefined);
